/*
 * @Desc:
 * @Author: wanglidong 王立冬
 * @Date: 2023-05-19 11:00:36
 * @LastEditors: lc
 * @LastEditTime: 2023-11-16 17:30:50
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
 */
/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'

const admin = {
  path: '/admin',
  component: Layout,
  redirect: 'noredirect',
  name: 'Admin',
  meta: {
    title: 'admin',
    icon: 'admin'
  },
  children: [
    {
      path: 'department',
      name: 'department',
      component: () => import('@/views/admin/Department'),
      meta: {
        title: '部门管理',
      }
    },
    {
      path: 'role',
      name: 'adminRole',
      component: () => import('@/views/admin/Role'),
      meta: {
        title: '角色管理',
      }
    },
    {
      path: 'index',
      component: () => import('@/views/admin/index'),
      name: 'adminIndex',
      meta: { title: '用户管理' }
    },
    {
      path: 'permission',
      component: () => import('@/views/admin/permission'),
      name: 'adminPermission',
      meta: { title: '权限管理' }
    },
    {
      path: 'updpwd',
      name: 'updpwd',
      component: () => import('@/views/admin/updpwd'),
      meta: {
        title: '修改密码',
      }
    },
  ]
}

export default admin
